import * as ExecutionEnvironment from 'exenv';
const isBrowserEnvironment: boolean = ExecutionEnvironment.canUseDOM;
export default isBrowserEnvironment;
